import "./price-list.scss";
import PriceCard from "./PriceCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper/modules";
import Spacing from "@/components/common/Spacing";

export interface PriceList {
  id?: string;
  title: string;
  text: string;
  price: string;
  links: string[];
  pack?: boolean;
  button?: string;
  hot?: boolean;
  offer?: boolean;  // 👈 ADD THIS
  webOffer?: boolean;  // 👈 ADD THIS LINE
  autumnOffer?: boolean;  // 👈 ADD THIS LINE
  individualPrice?: string;  // 👈 ADD THIS FOR PACK CARDS
  whatsappMessage?: string;  // 👈 ADD THIS FOR BLACK DAYS
}

interface PriceData {
  header: string;
  plans: PriceList[];
}

interface Props {
  data: PriceData;
}

const PriceList = ({ data }: Props) => {
  return (
    <div>
      <Spacing size={3} />
      <div className="header">
        <div className="title-2">PACHETE PRETURI</div>
        <div className="title-2">{data.header}</div>
      </div>
      <Spacing size={2} />
      <div className="swiper-container">
        <Swiper
          className="my-swiper"
          modules={[Pagination, FreeMode, Navigation]}
          pagination={{ clickable: true, type: "bullets" }}
          navigation={{
            prevEl: '.price-swiper-prev',
            nextEl: '.price-swiper-next',
          }}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            480: { slidesPerView: 1.3 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
        >
        {data.plans.map((item, index) => (
          <SwiperSlide key={index}>
            <PriceCard
              key={index}
              id={item.id}
              title={item.title}
              text={item.text}
              price={item.price}
              links={item.links}
              pack={item.pack}
              button={item.button}
              hot={item.hot}
              offer={item.offer}  // 👈 ADD THIS LINE!
              webOffer={item.webOffer}  // 👈 ADD THIS MISSING LINE!
              autumnOffer={item.autumnOffer}  // 👈 ADD THIS LINE!
              individualPrice={item.individualPrice}  // 👈 ADD THIS FOR PACK CARDS
              whatsappMessage={item.whatsappMessage}  // 👈 ADD THIS FOR BLACK DAYS

              section={
                data.header === "e-commerce" ? "e-commerce"
                : data.header === "ONLINE MARKETING" ? "online-marketing"
                : data.header === "BRANDING" ? "branding"  // ← ADD THIS!
                : data.header === "black-days" ? "black-days"  // ← ADD THIS!
                : "web-design"
              }
              />
          </SwiperSlide>
        ))}
        </Swiper>
        
        {/* Navigation arrows - always visible, Swiper handles disabled state */}
        <div className="price-swiper-prev swiper-nav-arrow">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="price-swiper-next swiper-nav-arrow">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      <Spacing size={3} />
    </div>
  );
};

export default PriceList;